import { IMetadata, WithMetadata } from './generic-responses.types';
import { Company, Currency, DocSubmission, FormType, ParamGeneralDacValueDto, RefParams } from './params.types';
import { Ppm, PpmMilestone } from './ppm.types';
import { ResponseDoc } from './response.types';
import { NextStep, Traceability } from './task-responses.types';
import { PassingMode } from './params.types';
import { TasksStatus } from './dac-responses.types';
import { DocType } from './dtos.types';
import { JointDoc } from './process-common';

// responses
export interface DacResponse {
  dacId: number;
  dacVer: number;
  aoId: number;
  aoReference: string;
  reference: string;
  ppm: Ppm;
  realisation: PpmMilestone;
  typeMarche: RefParams;
  modePassation: PassingMode;
  status: TasksStatus;
  processInstanceId: string | null;
  dynaDocs: DynaDocDetails[];
  dynaFields: DynaFieldWithDetails[];
  payant: boolean;
  etapeProcess: string;
  metadata: IMetadata;
  dacPrix: DacPrix[];
  dacShortlist: Company[];
  dynaForms: AttachedForm[];
  submissionPieces: DacDocSubmission[];
  etapeDac: string;
  conditionsParticipation: string;
  responsableDacId: string;
  dacModels: {
    aaoModel: string;
    dacModel: string;
  }[];

  documentCNCMPPermanente: JointDoc[];
  documentCNCMPSpecialise: JointDoc[];
  documentCPMP: JointDoc[];

  pvCNCMPPermanente: JointDoc[];
  pvCNCMPSpecialise: JointDoc[];
  pvCPMP: JointDoc[];

  extraitCNCMPP: JointDoc[];
  extraitCPMP: JointDoc[];

  nbrActualisation: number;
  actualise: boolean;

  dateLimiteSoumission: DacDate[];
  dateLimiteRecptionDemande: DacDate[];
  dateOuverture: DacDate[];
  dateDebutDepot: DacDate[];

  scenarioId: number;
  couldSubmitBiddersList?: boolean;
}

export interface DacDate {
  date?: Date;
  source?: string;
  status: 'ACTIF' | 'NON_ACTIF';
}

export interface DacOpinion {
  avis: string;
  user: string;
  createdAt: string;
  alfrescoId?: string;
}

export interface DynaDocDetails {
  id: number;
  version: number;
  name: string;
  templateFileName: string;
  guideFileName: string;
  typeMarche?: RefParams;
  dynaDocOrder: number;
  status: TasksStatus;
  dynaFields: DynaFieldWithDetails[];
  isStatic: boolean;
  docs?: ResponseDoc;
}

export interface DynaFieldWithDetails {
  dynaFieldsId: number;
  dynaDocsId: number;
  dynaDocsVer: number;
  name: string;
  ref: string;
  label: string;
  description: string;
  type: DynaFieldType;
  source: string;
  sourceField: string;
  dynaFieldsOrder: number;
  status: DynaStatus;
  dynaFieldsDetails: DynaFieldDetail[];
}

export interface DynaFieldDetail {
  dynaFieldsDetailsId: number;
  dynaDocsId: number;
  dynaDocsVer: number;
  dynaFieldsId: number;
  columnName: string;
  columnPos: number;
  fieldType: DynaFieldType;
  source: string;
  source_field: string;
}

export interface DacDetails {
  comId: number;
  avis: DacOpinion[];
  password: string;
  dateRequired: boolean;
  taskId: string;
  taskName: string;
  taskDefinitionKey: string;
  assignee: string;
  processInstanceId: string;
  created: string;
  candidateGroup: string;
  traceability: Traceability;
  dacDocs: WithMetadata<DacResponse>;
  dacPrix: DacPrix[];
  status: string;
  isUpdatable: boolean;
  isPublishable: boolean;
  hasTask: boolean;
  nextSteps: NextStep[];
  meetingRequired: boolean;
  passwordRequired: boolean;
}

export interface DacResponseSoft {
  dacId: number;
  referenceDac: string;
  realisation: string;
}
export enum DynaFieldType {
  TEXT = 'TEXT',
  INTEGER = 'INTEGER',
  DECIMAL = 'DECIMAL',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  LIST = 'LIST',
  TABLE = 'TABLE',
  SYSTEM = 'SYSTEM',
}

export enum DynaStatus {
  ACTIF = 'ACTIF',
  NON_ACTIF = 'NON_ACTIF',
}

//create dtos *****************************************
export interface DacCreateDto {
  appelOffreId?: number;
  dynaDocsModelId?: number;
}

//store utility
export interface DacCreateDtoSupport {
  aoRef: string;
  ppmRef: string;
  milestoneRef: string;
}

//update dtos *****************************************

export interface DacUpdateDto {
  dacId?: number;
  payant: boolean;
  responsableDacId?: string;
  conditionsParticipation: string;
  shortlistMembers: number[];
  dacPrixRequests: DacPrixRequest[];
  dacDocsRequests: DacFormFields[];
  dacDynaFormRequest: AttachedFormDto[];
  dateLimiteSoumission?: Date;
  dateLimiteRecptionDemande?: Date;
  dateOuverture?: Date;
  dateDebutDepot?: Date;
  parametrageGeneralDacValuesRequests: ParamGeneralDacValueDto[];
}

export interface DacUpdateConfigDto {
  scenarioId?: number;
  dacDocSoumissionCreateRequests: DacDocSubmissionDto[];
}

export interface DacListRequest {
  dacId: number;
  dacVer: number;
  dynaDocsVer?: number;
  dynaDocsId?: number;
  generateDocx?: boolean;
  dacDocsRequests: DacFormFields[];
  parametrageGeneralDacValuesRequests: ParamGeneralDacValueDto[];
}

export interface DacPrix {
  dacId: number;
  dacVer: number;
  monnaie: Currency;
  prix: number;
}

export interface DacPrixRequest {
  monnaieId: number;
  prix: number;
}

export interface DacFormFields {
  dacId: number;
  dynaFieldsId: number;
  dynaDocsId: number;
  fieldValue?: any;
  sourceId: string;
  docId?: number;
  details: FieldsDetail[];
}

export interface FieldsDetail {
  dynaFieldsDetailsId?: number;
  sourceId: string;
  fieldValue: string;
  rowId: number;
}

//********************************************************************************* */

export interface DynaFields {
  dynaFieldsId: number;
  dynaDocsId: number;
  dynaDocsVer: number;
  name: string;
  ref: string;
  label: string;
  description: string;
  type: DynaFieldType;
  source: string;
  sourceField: string;
  dynaFieldsOrder: number;
  status: DynaStatus;
  details?: {
    columnName?: string;
    columnPos?: number;
    type?: DynaFieldType;
    source?: string;
    sourceField?: string;
  }[];
}

export interface DynaDocsResponse {
  id: number;
  version: number;
  name: string;
  templateFileName: string;
  guideFileName: string;
  typeMarche: RefParams;
  modePassation?: PassingMode;
  dynaDocOrder: number;
  status: DynaStatus;
  type?: RefParams;
  fields: DynaFields[];
  isStatic: boolean;
  isAAO?: boolean;
  dynaDocsModel?: { id: number; description: string };
}

export interface DynamicDocCopy {
  id: number;
  version: number;
  name: string;
  ordre: number;
  isAAO: boolean;
  isStatic: boolean;
  status: DynaStatus;
  dynaDocs: {
    id: number;
    version: number;
  };
}

export interface DynaDocsDto {
  id: number;
  version: number;
  name?: string;
  templateFileName?: string;
  guideFileName?: string;
  typeMarcheId?: number;
  modePassationId?: number;
  typeId?: number;
  dynaDocOrder?: number;
  status?: DynaStatus;
  fields?: DynaFields[];
  isStatic: boolean;
  isAAO?: boolean;
  dynaDocsModelId?: number;
}

export interface PageResponse<T> {
  page: number;
  size: number;
  totalPages: number;
  total: number;
  first: boolean;
  last: boolean;
  empty: boolean;
  content: T[];
}

export interface ErrorResponse {
  status: number;
  message: string;
}

export interface TemplateResponse {
  templateName: string;
  fileName: string;
  mimeType: string;
  size: number;
  lastModified: number;
}

// One "**key**" marker found while scanning an uploaded template. suggestedType is derived
// purely from the marker's own syntax (a table:/list: prefix), not from any DB lookup.
export interface ExtractedPlaceholder {
  key: string;
  suggestedName: string;
  suggestedType: 'TEXT' | 'TABLE' | 'LIST';
}

export interface TemplatePlaceholders {
  placeholders: ExtractedPlaceholder[];
  // "**...**" markers found containing a space - not valid in this engine, nothing is
  // created for them; surfaced so they can be fixed in the document instead of only being
  // noticed as a leftover marker in a generated document later.
  suspicious: string[];
}

export interface DynaFieldsRequest {
  dynaDocsId: number;
  name: string;
  ref: string;
  label: string;
  description: string;
  type: DynaFieldType;
  source: string;
  sourceField: string;
  dynaFieldsOrder: number;
  status: DynaStatus;
  details?: {
    columnName?: string;
    columnPos?: number;
    typeId?: number;
    source?: string;
    sourceField?: string;
  }[];
}

export interface DacDocsFormResponse {
  dacId: number;
  dacVer: number;
  dynaDocId: number;
  dynaDocVersion: number;
  dynaFieldId: number;
  sourceId: string;
  fieldValue: string;
  dacDocDetails: {
    dynaFieldsDetailsId: number;
    rowId: number;
    columnPos: number;
    sourceId: string;
    fieldValue: string;
    dynaDocId: number;
    dynaDocVersion: number;
    dynaFieldId: number;
  }[];
}

export interface PreviewDocDacResponse {
  extension: string;
  filename: string;
  pdfBase64: string;
}

export interface PreviewDocDac {
  dacId: number;
  dacVer: number;
  dynaDocsId: number;
  dynaDocsVer: number;
}

export interface PreviewAaoDynaDoc {
  dacId: number;
  dacVersion: number;
  signataire: string;
  fonction: string;
  generateDocx: boolean;
}

//dynamic-form *******************************************
export interface AttachedForm {
  id: number;
  version: number;
  fields: AttachedField[];
  formType: FormType;
  name: string;
  order: number;
  status: DynaStatus;
  typeDossier: DocType;
}

export interface AttachedFormDto {
  dacId?: number;
  dacVer?: number;
  dynaFormId?: number;
  dynaFormVer?: number;
  dynaFormFieldsId: number[];
  display: boolean;
}

export interface DetachedFormDto {
  dacId: number;
  dacVer: number;
  dynaFormId: number;
  dynaFormVer: number;
}

export interface AttachedField {
  dacId: number;
  dacVer: number;
  dynaFormId: number;
  dynaFormVer: number;
  dynaFormFieldsId: number;
  display: boolean;
}

//******************************************

export interface DacDocSubmission {
  dacId: number;
  dateValidate: Date;
  nom: string;
  docSoumission: DocSubmission;
  commentaire?: string;
}

export interface DacDocSubmissionDto {
  dacId?: number;
  docSoumissionId?: number;
  dateValidate: Date;
  commentaire?: string;
}
